import { useRef, FC } from 'react';
import styled from 'styled-components';
import defaultUniLogoSrc from '../../../assets/images/uni_logo.png';

type Props = {
  src: string;
  alt?: string;
};

export const UniLogo: FC<Props> = ({ src, alt }) => {
  const imgRef = useRef<HTMLImageElement>(null);

  const handleOnError = () => {
    if (imgRef.current) {
      // @ts-ignore
      imgRef.current.src = defaultUniLogoSrc;
    }
  };

  return <ImgStyles ref={imgRef} src={src ?? defaultUniLogoSrc} alt={alt ?? 'Enroly Logo'} onError={handleOnError} />;
};

// https://github.com/microsoft/TypeScript/issues/47663#issuecomment-1519138189
const ImgStyles: ReturnType<ReturnType<typeof styled>> = styled.img`
  width: 118px;
`;
